import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ReferenceDataLabels } from '../../constants/reference-data-labels';

@Component({
  selector: 'boi-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent {
  private _src: string;
  public referenceDataLabels = ReferenceDataLabels;
  public page: number;
  public totalPages: number;
  public isLoaded = false;
  @ViewChild('pdfControls') pdfControls: ElementRef;

  @Input() public minZoom = 0.75;
  @Input() public zoom = 0.75;
  @Input() public set pdfSrc(value: string) {
    this.page = 1;
    this._src = value;
    this.isLoaded = false;
  }

  public get pdfSrc(): string {
    return this._src;
  }

  private readonly zoomConstUsedToTriggerRendering = 0.001;
  private zoomRerenderingIsNeeded = false;

  public afterLoadComplete(pdfData: any): void {
    this.totalPages = pdfData.numPages;
    this.isLoaded = true;
    this.reApplyCss();
  }

  public nextPage(): void {
    this.page++;
    this.prepareZoomRerendering();
  }

  public prevPage(): void {
    this.page--;
    this.prepareZoomRerendering();
  }

  public zoomIn(): void {
    if (this.zoom < 2) {
      this.zoom = this.zoom + 0.1;
    }
  }

  public zoomOut(): void {
    if (this.zoom <= 2.1) {
      this.zoom = this.zoom - 0.1;
    }
  }

  private prepareZoomRerendering(): void {
    this.zoom = this.zoom + this.zoomConstUsedToTriggerRendering;
    this.zoomRerenderingIsNeeded = true;
  }

  private triggerZoomRerendering(): void {
    this.zoom = this.zoom - this.zoomConstUsedToTriggerRendering;
    this.zoomRerenderingIsNeeded = false;
  }

  public onPageRendered(): void {
    // This zoom rerendering functionality was added to fix an ng2-pdf-viewer issue.
    // Pdf pages are not fully visible when changing pages on IE (issue 478) without this.
    if (this.zoomRerenderingIsNeeded) {
      this.triggerZoomRerendering();
    }
  }

  public onError(): void {
    this.isLoaded = true;
    this.reApplyCss();
  }

  // IE bug EMCBOISWS-21379
  public reApplyCss(): void {
    setTimeout(() => {
      this.pdfControls.nativeElement.style.height = '60px';
    }, 500);
  }
}
